import { createContext } from 'react'

export const AppUppdatePopupContext = createContext()
